import * as yup from "yup";

export const itemTemplateValidator = yup.object().shape({
  description: yup.string().required(),
  unit_cost: yup.number().required().max(999999999999.999),
  quantity: yup.number().required().min(0.01).max(9999999999.99),
  first_tax_rate_id: yup.number().nullable(),
  second_tax_rate_id: yup.number().nullable(),
});
